'use client';
import React from 'react';
import clsx from 'clsx';
import { Icon } from '@benzinga/core-ui';
import styles from './QuoteSlider.module.scss';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';

interface QuoteSliderProps {
  low?: number;
  high?: number;
  currentPrice?: number;
  open?: number;
  inverse?: boolean;
}

export const QuoteSlider = (props: QuoteSliderProps) => {
  const { currentPrice = 90, high = 100, inverse = false, low = 50, open } = props;

  const [percentage, setPercentage] = React.useState(0);
  const [openPercentage, setOpenPercentage] = React.useState(0);

  React.useEffect(() => {
    let tempLow = low;
    if (tempLow == 0) {
      tempLow = 1;
    }
    const redBarWidth = ((currentPrice - low) / (high - low)) * 100;
    let openBarWidth;
    if (open) {
      openBarWidth = ((open - low) / (high - low)) * 100;
    }
    setPercentage(redBarWidth);
    setOpenPercentage(openBarWidth);
  }, [currentPrice, high, low, open]);

  return (
    <div className={styles.quoteSliderWrapper}>
      <div className={clsx(styles.sliderWrapper, inverse && styles.inverse)}>
        <div className="quote-slider-bar" style={{ width: `${percentage}%` }} />
        <div className="quote-slider-tick" />
      </div>
      <div className="open-price-wrapper">
        <div className="transparent-box" style={{ width: `${openPercentage}%` }} />
        {open ? (
          <div className="open-price-container">
            <Icon icon={faCaretUp} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default QuoteSlider;

